/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessDpsStatusResponse } from '../../models/success-dps-status-response';

export interface GetDpsStatus$Params {
}

export function getDpsStatus(http: HttpClient, rootUrl: string, params?: GetDpsStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessDpsStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getDpsStatus.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessDpsStatusResponse>;
    })
  );
}

getDpsStatus.PATH = '/api/v1/session/dps-status';
